import Page from "../../layout/Page";
import MemberCreateForm from "../../forms/members/MemberCreateForm";

export default function MembersCreate(){
    return (
        <Page title="Invite A Member">
            <MemberCreateForm/>
        </Page>
    );
}